import styled from "styled-components";
import { styled as styledMui } from "@mui/material/styles";
import { SearchInput } from "components";

export const HeaderPanel = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const StyledSearchInput = styled(SearchInput)`
  margin-top: 13px;
  margin-right: 24px;
`;

export const Title = styledMui("div")(({ theme }) => ({
  margin: 0,
  fontFamily: "Avenir",
  fontWeight: 800,
  fontSize: 24,
  lineHeight: "33px",
  color: theme.palette.text.main,
  whiteSpace: "nowrap",
  textTransform: "none",
}));

export const NavContainer = styled.div`
  display: flex;

  .MuiInputBase-input {
    display: block;
  }
`;
